import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative items-center py-3" }
const _hoisted_2 = { class: "flex w-full justify-center" }
const _hoisted_3 = { class: "relative items-center py-3" }
const _hoisted_4 = { class: "flex w-full justify-center" }
const _hoisted_5 = { class: "relative items-center py-3" }
const _hoisted_6 = { class: "flex w-full justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isEditModalOpened,
    "no-padding": true,
    title: "Edit source",
    onToggleModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_form_wrapper, {
          "is-form-in-modal": true,
          "is-loading": _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Parking space", -1)),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.source.spaceId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.source.spaceId) = $event)),
                      options: _ctx.parkingSpaces,
                      reduce: (value) => value.id,
                      class: "w-full",
                      label: "name"
                    }, null, 8, ["modelValue", "options", "reduce"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Parking spot", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.source.spotId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.source.spotId) = $event)),
                      options: _ctx.parkingSpotsFiltered,
                      reduce: (value) => value.id,
                      class: "w-full",
                      label: "name"
                    }, null, 8, ["modelValue", "options", "reduce"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Parking spot type", -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.source.spotTypeId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.source.spotTypeId) = $event)),
                      options: _ctx.parkingSpotTypes,
                      reduce: (value) => value.id,
                      class: "w-full",
                      label: "name"
                    }, null, 8, ["modelValue", "options", "reduce"])
                  ])
                ]),
                _createVNode(_component_checkbox_input, {
                  modelValue: _ctx.source.showFree,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.source.showFree) = $event)),
                  "is-checked": _ctx.source.showFree,
                  label: "Show free"
                }, null, 8, ["modelValue", "is-checked"])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ], 32)
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}